<template>
  <div
    @click="containerClicked($event)"
    id="edit-sheet"
    v-if="sheet"
    :class="{
      projectNotActive:
        !sheet.project.status &&
        $store.getters.getAuth['userType'] === 'craftsmen',
    }"
  >
    <div :class="{ 'content-wrapper': true }">
      <div class="page-content fade-in-up">
        <div class="row">
          <div class="col-md-12">
            <div class="ibox" :style="{ backgroundColor: sheet.project.color }">
              <div
                v-if="$store.getters.getAuth['userType'] === 'superuser'"
                class="go-back"
                @click="goBack"
              >
                <i style="padding: 3px" class="fa fa-arrow-left"></i>
                <span
                  class="backToButton"
                  style="padding: 3px"
                  v-show="$store.getters.getLastRoute === 'EditProject'"
                  >{{ $t("message.backToProjectPage") }}</span
                >
                <span
                  class="backToButton"
                  style="padding: 3px"
                  v-show="$store.getters.getLastRoute === 'Dashboard'"
                  >{{ $t("message.backToDashboard") }}</span
                >
                <span
                  class="backToButton"
                  style="padding: 3px"
                  v-show="$store.getters.getLastRoute === 'Tasks'"
                  >{{ $t("message.backToTasks") }}</span
                >
              </div>
              <div
                v-if="
                  sheet.is_closed &&
                  $store.getters.getAuth['userType'] !== 'superuser'
                "
                class="row"
              >
                <div class="col-md-12 mt-5 text-center">
                  <div>
                    <h2>{{ $t("message.closedByAdministrator") }}</h2>
                  </div>
                </div>
              </div>

              <div
                v-if="sheet"
                :class="{ 'ibox-body': true }"
                :style="{
                  'pointer-events': computedSheetClosedStyles['pointerEvents'],
                  opacity: computedSheetClosedStyles['opacity'],
                }"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center table-responsive">
                      <table
                        v-if="craftsmanData"
                        class="table-bordered mx-auto w-auto craftsman-table"
                      >
                        <tbody>
                          <tr>
                            <td>{{ $t("message.companyName") }}:</td>
                            <td style="background: #e9ecef">
                              {{ craftsmanData.company_name }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.contractNumber") }}:</td>
                            <td style="background: #e9ecef">
                              {{ sheet.contract_number }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.firstName") }}:</td>
                            <td>{{ craftsmanData.first_name }}</td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.lastName") }}:</td>
                            <td>{{ craftsmanData.last_name }}</td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.email") }}:</td>
                            <td>
                              <a :href="`mailto:${craftsmanData.email}`">{{
                                craftsmanData.email
                              }}</a>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.companyWebsite") }}:</td>
                            <td>{{ craftsmanData.company_website }}</td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.businessMobile") }}:</td>
                            <td>{{ craftsmanData.businessMobile }}</td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.privateMobile") }}:</td>
                            <td>{{ craftsmanData.privateMobile }}</td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.targetCost") }}:</td>
                            <td>
                              <div
                                style="vertical-align: middle"
                                class="form-group"
                              >
                                <formatted-input
                                  :value="sheet.target_budget"
                                  :disabled="
                                    $store.getters.getAuth['userType'] ===
                                    'craftsmen'
                                  "
                                  @emit-value="updateTargetCost"
                                ></formatted-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div>{{ $t("message.staticBudget") }}:</div>
                              <table
                                v-if="
                                  $store.getters.getAuth['userType'] ===
                                  'superuser'
                                "
                              >
                                <tr>
                                  <td>{{ $t("message.lockStaticBudget") }}:</td>
                                  <td>
                                    <input
                                      type="checkbox"
                                      style="margin-top: 5px"
                                      v-model="sheet.is_locked_for_craftsman"
                                    />
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td>
                              <div
                                style="vertical-align: middle"
                                class="form-group"
                              >
                                <formatted-input
                                  :value="sheet.static_budget"
                                  @emit-value="updateStaticBudget"
                                  :key="componentKey"
                                  :disabled="sheet.is_locked_for_craftsman"
                                ></formatted-input>
                              </div>
                              <div v-if="additionalBudgetList.length">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th colspan="7">
                                        {{
                                          $t("message.additionalBudgetHistory")
                                        }}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style="white-space: nowrap">
                                        {{ $t("message.serialNumber") }}
                                      </th>
                                      <th style="white-space: nowrap">
                                        {{ $t("message.description") }}
                                      </th>
                                      <th style="white-space: nowrap">
                                        {{ $t("message.offerNumber") }}
                                      </th>
                                      <th style="white-space: nowrap">
                                        {{ $t("message.forMonth") }}
                                      </th>
                                      <th>{{ $t("message.amount") }}(CHF)</th>
                                      <th>{{ $t("message.date") }}</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(
                                        additional, index
                                      ) in additionalBudgetList"
                                      :key="index"
                                    >
                                      <td style="text-align: center">
                                        {{ additional.serial_number }}
                                      </td>
                                      <td style="text-align: center">
                                        {{ additional.description }}
                                      </td>
                                      <td style="text-align: center">
                                        {{ additional.offer_number }}
                                      </td>
                                      <td style="text-align: center">
                                        {{
                                          removeDayFromDate(
                                            additional.month_of_allocation
                                          )
                                        }}
                                      </td>
                                      <td style="text-align: right">
                                        {{ additional.amount }}
                                      </td>
                                      <td style="font-weight: bold">
                                        {{ additional.date }}
                                      </td>
                                      <td style="text-align: right">
                                        <span
                                          v-if="
                                            $store.getters.getAuth[
                                              'userType'
                                            ] === 'superuser'
                                          "
                                          style="cursor: pointer"
                                          ><i
                                            @click="
                                              deleteAdditionalBudget(
                                                additional.id
                                              )
                                            "
                                            class="fa fa-trash"
                                          ></i
                                        ></span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {{
                                $t("message.staticBudgetPlusAdditionalBudget")
                              }}:
                            </td>
                            <td>
                              <div
                                style="vertical-align: middle"
                                class="form-group"
                              >
                                <formatted-input
                                  :value="staticPlusAdditional"
                                  :key="componentKey"
                                  :disabled="true"
                                ></formatted-input>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.totalInvoiced") }}:</td>
                            <td>
                              <div
                                style="vertical-align: middle"
                                class="form-group"
                              >
                                <input
                                  style="text-align: right"
                                  type="text"
                                  :value="formatNumber(sheet.total_invoiced)"
                                  class="form-control"
                                  disabled
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.startDate") }}:</td>
                            <td>
                              <input
                                id="start-date"
                                v-model="sheet.start_date"
                                type="text"
                                class="form-control"
                              />
                              <month-picker
                                :default-month="defaultStartDate.month"
                                :default-year="defaultStartDate.year"
                                v-show="showMonthPicker && startDate"
                                :lang="$store.getters.getLocale"
                                @change="setDate($event, sheet, 'start_date')"
                              ></month-picker>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("message.endDate") }}:</td>
                            <td>
                              <input
                                id="end-date"
                                v-model="sheet.end_date"
                                type="text"
                                class="form-control"
                              />
                              <month-picker
                                :default-month="defaultEndDate.month"
                                :default-year="defaultEndDate.year"
                                v-show="showMonthPicker && endDate"
                                :lang="$store.getters.getLocale"
                                @change="setDate($event, sheet, 'end_date')"
                              ></month-picker>
                            </td>
                          </tr>
                          <!--<tr>-->
                          <!--<td>{{$t('message.sendEmailAlerts')}}:</td>-->
                          <!--<td>-->
                          <!--<label class="switch">-->
                          <!--<input type="checkbox" v-model="sheet.send_email_alerts" @change="updateSendEmailAlerts()">-->
                          <!--<span class="slider"></span>-->
                          <!--</label>-->
                          <!--</td>-->
                          <!--</tr>-->
                          <tr
                            v-if="
                              $store.getters.getAuth['userType'] === 'superuser'
                            "
                          >
                            <td>{{ $t("message.closeSheet") }}:</td>
                            <td>
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-model="sheet.is_closed"
                                  @change="updateIsClosed()"
                                />
                                <span class="slider"></span>
                              </label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!--<div class="col-md-2">-->
                  <!--<div class="form-group">-->
                  <!--<label>{{$t('message.targetCost')}}</label>-->
                  <!--<input v-model="sheet.target_budget" type="number" class="form-control">-->
                  <!--<label>{{$t('message.staticBudget')}}</label>-->
                  <!--<input v-model="sheet.static_budget" type="number" class="form-control">-->
                  <!--<button @click="updateDetails" class="btn btn-info mr-2"-->
                  <!--style="margin-top: 20px">-->
                  <!--{{$t('message.update')}}{{$t('message.costsAndDates')}}-->
                  <!--</button>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="col-md-2">-->
                  <!--<div class="form-group">-->
                  <!--<label>{{$t('message.startDate')}}</label><input v-model="sheet.start_date"-->
                  <!--type="date"-->
                  <!--class="form-control">-->
                  <!--<label>{{$t('message.endDate')}}</label><input v-model="sheet.end_date"-->
                  <!--type="date"-->
                  <!--class="form-control">-->
                  <!--</div>-->
                  <!--</div>-->

                  <!--<div class="col-md-2">-->
                  <!--<div>-->
                  <!--<p><span class="font-bold">{{$t('message.currentDate')}}:</span><br>-->
                  <!--<span>{{$moment().format(formatString)}} </span></p>-->
                  <!--<p><span class="font-bold">{{$t('message.dateLastFriday')}}:</span><br>-->
                  <!--<span>{{getLastFriday()}}</span>-->
                  <!--</p>    -->
                  <!--</div>      -->
                  <!--</div>-->
                </div>

                <div class="row">
                  <div class="col-md-12 text-center">
                    <button
                      @click="
                        updateDetails();
                        calculateStaticPlusAdditional();
                      "
                      class="btn btn-info mr-2"
                      style="margin-top: 20px"
                    >
                      {{ $t("message.update")
                      }}{{ $t("message.costsAndDates") }}
                    </button>
                    <button
                      @click="downloadToCsv"
                      class="btn btn-success mr-2"
                      style="margin-top: 20px; margin-right: 15px"
                    >
                      {{ $t("message.downloadToCsv") }}
                    </button>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-md-12">
                        <button
                          @click="openNotes"
                          v-if="
                            $store.getters.getAuth['userType'] === 'superuser'
                          "
                          class="btn btn-block btn-primary mb-3"
                        >
                          {{ $t("message.notes") }}
                          <span v-if="numberOfNotes > 0"
                            class="badge badge-pill badge-danger"
                            style="
                              width: 25px;
                              position: absolute;
                              margin-left: 2%;
                              margin-top: -0.5%;
                            "
                            >{{ numberOfNotes }}</span
                          >
                        </button>
                        <button
                          @click="importCategories"
                          class="btn btn-block btn-primary mb-3"
                        >
                          {{ $t("message.importCategories") }}
                        </button>
                        <table
                          style="font-size: 0.9em"
                          class="table table-striped loaded-categories-table"
                        >
                          <thead>
                            <tr>
                              <th style="width: 50%">
                                {{ $t("message.categoriesPersonnel") }}
                              </th>
                              <th style="width: 25%">
                                {{ $t("message.chfPerHour") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="categories['personnel'].length !== 0">
                            <tr
                              class="change-color"
                              v-for="(category, index) in computedCategories[
                                'personnel'
                              ]"
                              @click="approveAdditionalCategory(category)"
                              :class="{
                                additionalCategory:
                                  category.is_additional &&
                                  !category.is_approved,
                                additionalCategoriesApproved:
                                  category.is_additional &&
                                  category.is_approved,
                              }"
                              :key="index"
                            >
                              <td
                                style="vertical-align: middle"
                                @click="updateCategoryNameDialog(category)"
                              >
                                {{ category.name }}
                              </td>
                              <td
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ category.value }}
                              </td>
                              <td>
                                <button
                                  v-if="
                                    $store.getters.getAuth['userType'] ===
                                    'superuser'
                                  "
                                  @click="deleteCategory(category.id)"
                                  class="btn btn-lg"
                                  style="
                                    padding-bottom: 17px;
                                    background-color: transparent;
                                  "
                                >
                                  <i
                                    class="fa fa-trash add-category-button-plus"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="tooltip-wrapper">
                          <button
                            @click="
                              addCategoryDialog({
                                type: 'personnel',
                                heading: $t('message.addCategoriesPersonnel'),
                                name: $t('message.name'),
                                value: $t('message.chfPerHour'),
                              })
                            "
                            @mouseover="showToolTipPersonnel = true"
                            @mouseleave="showToolTipPersonnel = false"
                            class="add-category-button btn btn-success btn-circle add-project-btn"
                          >
                            <i class="fa fa-plus add-category-button-plus"></i>
                          </button>
                          <span
                            class="tooltiptext"
                            v-bind:class="{ visible: showToolTipPersonnel }"
                          >
                            {{ $t(`message.addACategory`) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <table
                          style="font-size: 0.9em"
                          class="table table-striped loaded-categories-table"
                        >
                          <thead>
                            <tr>
                              <th style="width: 50%">
                                {{ $t("message.material") }}
                              </th>
                              <th style="width: 25%">
                                {{ $t("message.surcharge") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="categories['material'].length !== 0">
                            <tr
                              class="change-color"
                              v-for="(
                                category, index
                              ) in computedCategories.material"
                              @click="approveAdditionalCategory(category)"
                              :key="index"
                              :class="{
                                additionalCategory:
                                  category.is_additional &&
                                  !category.is_approved,
                                additionalCategoriesApproved:
                                  category.is_additional &&
                                  category.is_approved,
                              }"
                            >
                              <td
                                style="vertical-align: middle"
                                @click="updateCategoryNameDialog(category)"
                              >
                                {{ category.name }}
                              </td>
                              <td
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ category.value }}
                              </td>
                              <td>
                                <button
                                  v-if="
                                    $store.getters.getAuth['userType'] ===
                                    'superuser'
                                  "
                                  @click="deleteCategory(category.id)"
                                  class="btn btn-lg"
                                  style="
                                    padding-bottom: 17px;
                                    background-color: transparent;
                                  "
                                >
                                  <i
                                    class="fa fa-trash add-category-button-plus"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="tooltip-wrapper">
                          <button
                            @click="
                              addCategoryDialog({
                                type: 'material',
                                heading: $t('message.addCategoriesMaterial'),
                                name: $t('message.material'),
                                value: $t('message.surcharge'),
                              })
                            "
                            @mouseover="showToolTipMaterial = true"
                            @mouseleave="showToolTipMaterial = false"
                            class="add-category-button btn btn-success btn-circle add-project-btn"
                          >
                            <i class="fa fa-plus add-category-button-plus"></i>
                          </button>
                          <span
                            class="tooltiptext"
                            v-bind:class="{ visible: showToolTipMaterial }"
                          >
                            {{ $t(`message.addACategory`) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <table
                          style="font-size: 0.9em"
                          class="table table-striped loaded-categories-table"
                        >
                          <thead>
                            <tr>
                              <th style="width: 50%">
                                {{ $t("message.foreignService") }}
                              </th>
                              <th style="width: 25%">
                                {{ $t("message.surcharge") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            v-if="categories['foreign power'].length !== 0"
                          >
                            <tr
                              class="change-color"
                              v-for="(category, index) in computedCategories[
                                'foreign power'
                              ]"
                              @click="approveAdditionalCategory(category)"
                              :class="{
                                additionalCategory:
                                  category.is_additional &&
                                  !category.is_approved,
                                additionalCategoriesApproved:
                                  category.is_additional &&
                                  category.is_approved,
                              }"
                              :key="index"
                            >
                              <td
                                style="vertical-align: middle"
                                @click="updateCategoryNameDialog(category)"
                              >
                                {{ category.name }}
                              </td>
                              <td
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ category.value }}
                              </td>
                              <td>
                                <button
                                  v-if="
                                    $store.getters.getAuth['userType'] ===
                                    'superuser'
                                  "
                                  @click="deleteCategory(category.id)"
                                  class="btn btn-lg"
                                  style="
                                    padding-bottom: 17px;
                                    background-color: transparent;
                                  "
                                >
                                  <i
                                    class="fa fa-trash add-category-button-plus"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="tooltip-wrapper">
                          <button
                            @click="
                              addCategoryDialog({
                                type: 'foreign power',
                                heading: $t(
                                  'message.addCategoriesForeignService'
                                ),
                                name: $t('message.foreignService'),
                                value: $t('message.surcharge'),
                              })
                            "
                            @mouseover="showToolTipForeignService = true"
                            @mouseleave="showToolTipForeignService = false"
                            class="add-category-button btn btn-success btn-circle add-project-btn"
                          >
                            <i class="fa fa-plus add-category-button-plus"></i>
                          </button>
                          <span
                            class="tooltiptext"
                            v-bind:class="{
                              visible: showToolTipForeignService,
                            }"
                          >
                            {{ $t(`message.addACategory`) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <table
                          style="font-size: 0.9em"
                          class="table table-striped loaded-categories-table"
                        >
                          <thead>
                            <tr>
                              <th style="width: 50%">
                                {{ $t("message.inventory") }}
                              </th>
                              <th style="width: 25%">
                                {{ $t("message.surcharge") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="categories['inventory'].length !== 0">
                            <tr
                              class="change-color"
                              v-for="(
                                category, index
                              ) in computedCategories.inventory"
                              :key="index"
                              @click="approveAdditionalCategory(category)"
                              :class="{
                                additionalCategory:
                                  category.is_additional &&
                                  !category.is_approved,
                                additionalCategoriesApproved:
                                  category.is_additional &&
                                  category.is_approved,
                              }"
                            >
                              <td
                                style="vertical-align: middle"
                                @click="updateCategoryNameDialog(category)"
                              >
                                {{ category.name }}
                              </td>
                              <td
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ category.value }}
                              </td>
                              <td>
                                <button
                                  v-if="
                                    $store.getters.getAuth['userType'] ===
                                    'superuser'
                                  "
                                  @click="deleteCategory(category.id)"
                                  class="btn btn-lg"
                                  style="
                                    padding-bottom: 17px;
                                    background-color: transparent;
                                  "
                                >
                                  <i
                                    class="fa fa-trash add-category-button-plus"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="tooltip-wrapper">
                          <button
                            @click="
                              addCategoryDialog({
                                type: 'inventory',
                                heading: $t('message.addCategoriesInventory'),
                                name: $t('message.inventory'),
                                value: $t('message.amount'),
                              })
                            "
                            @mouseover="showToolTipInventory = true"
                            @mouseleave="showToolTipInventory = false"
                            class="add-category-button btn btn-success btn-circle add-project-btn"
                          >
                            <i class="fa fa-plus add-category-button-plus"></i>
                          </button>
                          <span
                            class="tooltiptext"
                            v-bind:class="{ visible: showToolTipInventory }"
                          >
                            {{ $t(`message.addACategory`) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <table
                          style="font-size: 0.9em"
                          class="table table-striped loaded-categories-table"
                        >
                          <thead>
                            <tr>
                              <th style="width: 50%">
                                {{ $t("message.additionalCosts") }}
                              </th>
                              <th style="width: 25%">
                                {{ $t("message.unit") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            v-if="categories['additional costs'].length !== 0"
                          >
                            <tr
                              class="change-color"
                              v-for="(category, index) in computedCategories[
                                'additional costs'
                              ]"
                              @click="approveAdditionalCategory(category)"
                              :class="{
                                additionalCategory:
                                  category.is_additional &&
                                  !category.is_approved,
                                additionalCategoriesApproved:
                                  category.is_additional &&
                                  category.is_approved,
                              }"
                              :key="index"
                            >
                              <td
                                style="vertical-align: middle"
                                @click="updateCategoryNameDialog(category)"
                              >
                                {{ category.name }}
                              </td>
                              <td
                                style="
                                  text-align: center;
                                  vertical-align: middle;
                                "
                              >
                                {{ category.value }}
                              </td>
                              <td>
                                <button
                                  v-if="
                                    $store.getters.getAuth['userType'] ===
                                    'superuser'
                                  "
                                  @click="deleteCategory(category.id)"
                                  class="btn btn-lg"
                                  style="
                                    padding-bottom: 17px;
                                    background-color: transparent;
                                  "
                                >
                                  <i
                                    class="fa fa-trash add-category-button-plus"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="tooltip-wrapper">
                          <button
                            @click="
                              addCategoryDialog({
                                type: 'additional costs',
                                heading: $t(
                                  'message.addCategoriesAdditionalCosts'
                                ),
                                name: $t('message.additionalCosts'),
                                value: $t('message.amount'),
                              })
                            "
                            @mouseover="showToolTipAdditionalCosts = true"
                            @mouseleave="showToolTipAdditionalCosts = false"
                            class="add-category-button btn btn-success btn-circle add-project-btn"
                          >
                            <i class="fa fa-plus add-category-button-plus"></i>
                          </button>
                          <span
                            class="tooltiptext"
                            v-bind:class="{
                              visible: showToolTipAdditionalCosts,
                            }"
                          >
                            {{ $t(`message.addACategory`) }}
                          </span>
                        </div>
                      </div>

                      <table class="table table-bordered">
                        <tr>
                          <td style="vertical-align: middle; font-size: 12px">
                            <strong>{{ $t("message.description") }}:</strong>
                          </td>
                          <td>
                            <input
                              v-model="additionalBudgetDescription"
                              class="form-control"
                              style="margin-top: 5px"
                              type="text"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: middle; font-size: 12px">
                            <strong>{{ $t("message.offerNumber") }}:</strong>
                          </td>
                          <td>
                            <input
                              v-model="additionalBudgetOfferNumber"
                              class="form-control"
                              style="margin-top: 5px"
                              type="text"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: middle; font-size: 12px">
                            <strong>{{ $t("message.total") }}:</strong>
                          </td>
                          <td>
                            <formatted-input
                              :value="additionalBudgetSum"
                              :key="componentKey"
                              :disabled="true"
                            ></formatted-input>
                          </td>
                        </tr>
                        <tr
                          v-for="(
                            selectedMonthAdditionalBudget, index
                          ) in selectedMonthAdditionalBudgets"
                          :key="index"
                        >
                          <td>
                            <select
                              v-model="selectedMonthAdditionalBudget.value"
                              style="width: 100px"
                            >
                              <option
                                v-for="(
                                  additionalBudgetMonth, index
                                ) in additionalBudgetMonthsList"
                                :value="additionalBudgetMonth"
                                :key="index"
                              >
                                {{ removeDayFromDate(additionalBudgetMonth) }}
                              </option>
                            </select>
                          </td>
                          <td>
                            <input
                              v-model="selectedMonthAdditionalBudget.amount"
                              class="form-control"
                              @input="calculateAdditionalBudgetTotal"
                              style="margin-top: 5px"
                              type="number"
                            />
                          </td>
                        </tr>
                        <!-- <tr v-for="(additionalBudgetMonth, key) in additionalBudgetMonths" :key="key">
                                                  <td>{{ additionalBudgetMonth.month }}<td></td>
                                              </tr>  -->

                        <!-- <tr v-for="(additionalBudgetMonth, key) in additionalBudgetMonths" :key="key">
                                                    <td>{{ additionalBudgetMonth.month }}</td>
                                                </tr>  -->
                      </table>
                      <div class="col-md-12">
                        <div>
                          <button
                            :disabled="sheet.requested_additional_budget"
                            @click="removeSelectInputRow"
                            class="btn btn-danger addRemoveAddBudgetButton"
                          >
                            {{ $t("message.removeAdditionalBudget") }}
                          </button>
                          <button
                            :disabled="sheet.requested_additional_budget"
                            @click="addSelectInputRow"
                            class="btn btn-success addRemoveAddBudgetButton"
                          >
                            {{ $t("message.addAdditionalBudget") }}
                          </button>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button
                          v-if="
                            $store.getters.getAuth['userType'] === 'superuser'
                          "
                          @click="addAdditionalBudget"
                          :class="{
                            btn: true,
                            'btn-block': true,
                            'btn-primary': true,
                            requireAdditionalBudgetDisabled:
                              sheet.requested_additional_budget,
                          }"
                          style="font-size: 0.9em; width: 99%"
                        >
                          {{ $t("message.saveAdditionalBudget") }}
                        </button>
                        <button
                          v-else
                          @click="requestAdditionalBudget"
                          :class="{
                            btn: true,
                            'btn-block': true,
                            'btn-primary': true,
                            requireAdditionalBudgetDisabled:
                              sheet.requested_additional_budget,
                          }"
                          style="font-size: 0.9em; width: 99%"
                        >
                          {{ $t("message.requestAdditionalBudget") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <ul class="nav nav-tabs tabs-line">
                      <li class="nav-item" @click="selectActiveTab('Budget')">
                        <div @click="setActiveClass('personnel')">
                          <div @click="budgetOrActual = 'Budget'">
                            <router-link
                              style="padding: 10px; border-radius: 5px"
                              :class="{
                                budget: activeTab === 'Budget',
                                active: budgetActualComputed === 'Budget',
                              }"
                              :to="{
                                name: 'BudgetCostsWork',
                                params: {
                                  id: sheet.id,
                                  type: 'personnel',
                                  heading: 'work',
                                },
                              }"
                              data-toggle="tab"
                            >
                              {{ $t("message.budget") }}
                            </router-link>
                          </div>
                        </div>
                      </li>
                      <li
                        class="nav-item"
                        @click="selectActiveTab('Actual costs')"
                      >
                        <div @click="setActiveClass('personnel')">
                          <div @click="budgetOrActual = 'Actual'">
                            <router-link
                              style="padding: 10px; border-radius: 5px"
                              :class="{
                                actual: activeTab === 'Actual costs',
                                active: budgetActualComputed === 'Actual',
                              }"
                              :to="{
                                name: 'ActualCostsWork',
                                params: {
                                  id: sheet.id,
                                  type: 'personnel',
                                  heading: 'work',
                                },
                              }"
                              data-toggle="tab"
                            >
                              {{ $t("message.actualCosts") }}
                            </router-link>
                          </div>
                        </div>
                      </li>
                      <li class="nav-item" @click="selectActiveTab('Summary')">
                        <router-link
                          style="padding: 10px; border-radius: 5px"
                          :to="{
                            name: 'SheetSummary',
                            params: { id: sheet.id },
                          }"
                          :class="{ summary: activeTab === 'Summary' }"
                          data-toggle="tab"
                          >{{ $t("message.summary") }}
                        </router-link>
                      </li>
                      <li
                        class="nav-item"
                        @click="selectActiveTab('Total invoiced')"
                      >
                        <router-link
                          style="padding: 10px; border-radius: 5px"
                          :to="{
                            name: 'TotalInvoiced',
                            params: { id: sheet.id },
                          }"
                          :class="{
                            totalInvoiced: activeTab === 'Total invoiced',
                          }"
                          data-toggle="tab"
                          >{{ $t("message.totalInvoiced") }}
                        </router-link>
                      </li>
                      <li
                        class="nav-item"
                        @click="selectActiveTab('Documents')"
                      >
                        <router-link
                          style="padding: 10px; border-radius: 5px"
                          :to="{ name: 'Documents', params: { id: sheet.id } }"
                          :class="{ documents: activeTab === 'Documents' }"
                          data-toggle="tab"
                          >{{ $t("message.documents") }}
                        </router-link>
                      </li>
                    </ul>
                    <div
                      v-if="showCategoryTypeTab"
                      class="flex-container text-center"
                    >
                      <div
                        :class="{
                          activeType: active.personnel,
                          notActiveType: !active.personnel,
                        }"
                      >
                        <span @click="setActiveClass('personnel')">
                          <router-link
                            :to="{
                              name: `${budgetActualComputed}CostsWork`,
                              params: {
                                id: sheet.id,
                                type: 'personnel',
                                heading: 'work',
                              },
                            }"
                            >{{ $t("message.job") }}
                          </router-link>
                        </span>
                      </div>
                      <div
                        :class="{
                          activeType: active.material,
                          notActiveType: !active.material,
                        }"
                      >
                        <span @click="setActiveClass('material')">
                          <router-link
                            :to="{
                              name: `${budgetActualComputed}MaterialCost`,
                              params: {
                                id: sheet.id,
                                type: 'material',
                                heading: 'material',
                              },
                            }"
                            >{{ $t("message.material") }}
                          </router-link>
                        </span>
                      </div>
                      <div
                        :class="{
                          activeType: active['foreign power'],
                          notActiveType: !active['foreign power'],
                        }"
                      >
                        <span @click="setActiveClass('foreign power')">
                          <router-link
                            :to="{
                              name: `${budgetActualComputed}ForeignPower`,
                              params: {
                                id: sheet.id,
                                type: 'foreign power',
                                heading: 'foreignService',
                              },
                            }"
                            >{{ $t("message.foreignService") }}
                          </router-link>
                        </span>
                      </div>
                      <div
                        :class="{
                          activeType: active.inventory,
                          notActiveType: !active.inventory,
                        }"
                      >
                        <span @click="setActiveClass('inventory')">
                          <router-link
                            :to="{
                              name: `${budgetActualComputed}Inventory`,
                              params: {
                                id: sheet.id,
                                type: 'inventory',
                                heading: 'inventory',
                              },
                            }"
                            >{{ $t("message.inventory") }}
                          </router-link>
                        </span>
                      </div>
                      <div
                        :class="{
                          activeType: active['additional costs'],
                          notActiveType: !active['additional costs'],
                        }"
                      >
                        <span @click="setActiveClass('additional costs')">
                          <router-link
                            :to="{
                              name: `${budgetActualComputed}AdditionalCosts`,
                              params: {
                                id: sheet.id,
                                type: 'additional costs',
                                heading: 'additionalCosts',
                              },
                            }"
                            >{{ $t("message.additionalCosts") }}
                          </router-link>
                        </span>
                      </div>
                    </div>

                    <router-view
                      ref="costTable"
                      @addNote="addNote"
                      @totalInvoiced="totalInvoiced"
                      @importCategories="handleImportCategories"
                      @updateCategoryName="updateCategoryName"
                      @sheetChanged="sheetChanged"
                      @budgetDone="confirmBudgetDone"
                      @confirmCategory="confirmCategory"
                      @passAddCategory="addCategory"
                      @confirmDeleteCategory="confirmDeleteCategory"
                      @deleteNote="confirmDeleteNote"
                      @confirmDeleteAdditionalBudget="
                        confirmDeleteAdditionalBudget
                      "
                      :lastCategory="computedLastCategory"
                      :key="$route.name + $store.getters.getLocale"
                      v-if="categories.length !== 0 && sheet"
                      :categories="computedCategories"
                      :sheet="sheet"
                    ></router-view>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputModal from "../../modals/InputModal";
import NotesModal from "../../modals/NotesModal";
import ImportCategoriesModal from "../../modals/ImportCategoriesModal";
import OkModal from "../../modals/OkModal";
import DialogModal from "../../modals/DialogModal";
import NameModal from "../../modals/NameModal";
import { MonthPicker } from "vue-month-picker";
import FormattedInput from "../misc/FormattedInput";
//import EventBus from '../../../static/js/event-bus';

export default {
  name: "EditSheet",
  data() {
    return {
      staticPlusAdditional: 0,
      additionalBudgetSum: 0,
      additionalBudgetCounter: 0,
      additionalBudgetList: [],
      selectedMonthAdditionalBudgets: [],
      additionalBudgetMonthsList: [],
      additionalBudgetMonths: [],
      additionalBudgetDescription: "",
      additionalBudgetOfferNumber: "",
      componentKey: 0,
      numberOfNotes: 0,
      componentKeyAdditionalBudget: 0,
      activeTab: "Actual costs",
      additionalBudget: 0,
      succesfullyUploadedFiles: 0,
      totalInvoicedAmount: null,
      documents: [],
      months: [],
      selectedMonth: null,
      fileList: [],
      showCategoryTypeTab: true,
      dontSetDateOnMount: false,
      showMonthPicker: false,
      setStartDateOnMount: false,
      setEndDateOnMount: false,
      defaultStartDate: {
        year: null,
        month: null,
      },
      defaultEndDate: {
        year: null,
        month: null,
      },
      endDate: false,
      startDate: false,
      currentDocumentIndex: null,
      showToolTipDocument: false,
      showToolTipPersonnel: false,
      showToolTipMaterial: false,
      showToolTipForeignService: false,
      showToolTipInventory: false,
      showToolTipAdditionalCosts: false,
      craftsmanData: null,
      budgetOrActual: "Actual",
      lastCategoryAdded: null,
      sheet: null,
      job: null,
      categories: {
        personnel: [],
        material: [],
        "foreign power": [],
        inventory: [],
        "additional costs": [],
      },
      active: {
        personnel: true,
        material: false,
        "foreign power": false,
        inventory: false,
        "additional costs": false,
      },
    };
  },
  components: {
    MonthPicker,
    FormattedInput,
  },
  props: ["id", "lastRoute", "projectId"],
  created() {
    if (this.$route.name.startsWith("Budget")) {
      this.budgetOrActual = "Budget";
    } else {
      this.budgetOrActual = "Actual";
    }

    this.setLastRouteProjectId();
    this.setActiveClass(this.$route.params["type"]);
    // method for getting overall data of the sheet
    this.getSheetData();

    // method for getting the list of categories
    this.getCategoriesList();
    
    if (this.$store.getters.getAuth["userType"] === "superuser"){
      this.getNumberOfNotes();
    }
  },
  methods: {
    addNote(){
      this.numberOfNotes++;
    },
    getNumberOfNotes() {
      this.get(
        this.apiPrefix,
        this.sheetApiUrl + "notes-count-number/",
        "",
        this.id
      )
        .then((resp) => {
          this.numberOfNotes = resp.data["number"];
         // console.log(this.numberOfNotes)
        })
        .catch((err) => {
          console.log(err);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    getCategoriesList() {
      this.getList(
        this.apiPrefix,
        this.categoriesApiUrl,
        `?sheet__id=${this.$route.params.id}`
      )
        .then((resp) => {
          this.categories["personnel"] = [];
          this.categories["personnel"] = [];
          this.categories["material"] = [];
          this.categories["foreign power"] = [];
          this.categories["inventory"] = [];
          this.categories["additional costs"] = [];

          for (const cat of resp.data) {
            this.sortCategoriesData(cat);
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    deleteCategory(id) {
      const msg = `${this.$t("message.areYouSureDeleteCategory")} ${this.$t(
        "message.pleaseNoteCostsAlso"
      )}`;

      this.$modal.show(
        DialogModal,
        {
          text: msg,
          param: id,
          textColor: "#c44133",
          event: "confirmDeleteCategory",
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    confirmDeleteCategory(id) {
      this.delete(this.apiPrefix, this.categoriesApiUrl, id)
        .then(() => {
          this.$modal.show(
            OkModal,
            {
              text: `${this.$t("message.category")} ${this.$t(
                "message.succesfullyDeleted"
              )}.`,
              modalClass: this.modalClasses.okSuccessClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );

          this.getCategoriesList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateSendEmailAlerts() {
      this.update(
        this.apiPrefix,
        this.sheetApiUrl + "set-send-email-alerts/",
        this.sheet.id,
        {
          send_email_alerts: this.sheet.send_email_alerts,
        }
      )
        .then((resp) => {
          console.log(resp.data);
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    updateIsClosed() {
      this.update(
        this.apiPrefix,
        this.sheetApiUrl + "set-sheet-closed/",
        this.sheet.id,
        {
          is_closed: this.sheet.is_closed,
        }
      )
        .then((resp) => {
          console.log(resp.data);
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    confirmDeleteNote(id) {
      this.delete(this.apiPrefix, this.noteApiUrl + "/", id)
        .then(() => {
          this.$modal.show(
            OkModal,
            {
              text: `${this.$t("message.note")} ${this.$t(
                "message.succesfullyDeleted"
              )}.`,
              modalClass: this.modalClasses.okSuccessClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );

          // subtract 1 note from notes counter
          this.numberOfNotes--;

          this.getList(
            this.apiPrefix,
            this.noteApiUrl,
            `?sheet_id=${this.sheet.id}`
          )
            .then((resp) => {
              this.$store.commit("setNotes", resp.data);
            })
            .catch();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openNotes() {
      this.$modal.show(
        NotesModal,
        {
          sheetId: this.sheet.id,
          heading: this.$t("message.updateNotes"),
        },
        {
          width: "700px",
          height: "auto",
        }
      );
    },
    calculateStaticPlusAdditional() {
      this.staticPlusAdditional = this.sheet.static_budget;

      for (let i = 0; i < this.additionalBudgetList.length; i++) {
        this.staticPlusAdditional += this.additionalBudgetList[i].amount;
      }

      this.componentKey++;
    },
    calculateAdditionalBudgetTotal() {
      this.additionalBudgetSum = 0;

      for (let i = 0; i < this.selectedMonthAdditionalBudgets.length; i++) {
        this.additionalBudgetSum += parseFloat(
          this.selectedMonthAdditionalBudgets[i].amount
        );
      }
      this.componentKey++;
    },
    addSelectInputRow() {
      this.selectedMonthAdditionalBudgets.push({
        value: null,
        amount: 0,
      });
    },
    removeSelectInputRow() {
      this.selectedMonthAdditionalBudgets.pop();
      // recalculate sum of additional budget after an element is removed
      this.calculateAdditionalBudgetTotal();
    },
    getArrayAdditionalBudgetMonth() {
      let date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      // get the first day of the current month and the first day of last month for an array of months additional budget
      let month = this.$moment(this.$moment(firstDay).format("YYYY-MM-DD"));
      let endMonth = this.$moment(this.sheet.project.end_date); //clone the startDate

      while (month <= endMonth) {
        this.additionalBudgetMonthsList.push(month.format("YYYY-MM-DD"));
        month.add(1, "month");
      }
    },
    addRowAdditionalBudgetMonth() {
      let date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      console.log(this.$moment(firstDay).format("YYYY-MM-DD"));
      console.log(this.sheet.project.end_date);
    },
    getSheetData() {
      this.get(this.apiPrefix, this.sheetApiUrl, "", this.id)
        .then((resp) => {
          const additional_budgets = resp.data.additional_budget_descriptions;
          this.additionalBudgetList = [];

          for (let i = 0; i < additional_budgets.length; i++)
            for (
              let j = 0;
              j < additional_budgets[i].additional_budgets.length;
              j++
            ) {
              let object = new Object();
              (object.serial_number = additional_budgets[i].serial_number),
                (object.description = additional_budgets[i].description),
                (object.offer_number = additional_budgets[i].offer_number);
              (object.id = additional_budgets[i].additional_budgets[j].id),
                (object.amount =
                  additional_budgets[i].additional_budgets[j].amount);
              object.month_of_allocation =
                additional_budgets[i].additional_budgets[j].month_of_allocation;
              object.date = additional_budgets[i].additional_budgets[j].date;
              this.additionalBudgetList.push(object);
            }

          this.sheet = resp.data;
          // format dates for showing them without day
          this.sheet.start_date = this.$moment(this.sheet.start_date).startOf('month').format('YYYY-MM')
          if(this.sheet.end_date){
            this.sheet.end_date = this.$moment(this.sheet.end_date).startOf('month').format('YYYY-MM')
          }

          this.setDefaultDateForMonthPicker(
            this.sheet.start_date,
            this.sheet.end_date
          );
          this.checkIfStaticBudgetZero();

          // use data for the list of months for drop down for additional budget
          this.getArrayAdditionalBudgetMonth();
          // recreate static budget custom component after supplying with data

          this.calculateStaticPlusAdditional();

          this.componentKey++;

          // if (resp.data.start_date !== null) {
          //   this.selectedMonth = resp.data.start_date;
          //   this.monthsFromStartDate(resp.data.start_date);
          // }

          this.get(
            this.apiPrefix,
            this.userApiUrl + "/",
            "",
            this.sheet.user.id
          )
            .then((resp) => {
              this.craftsmanData = resp.data;

              this.craftsmanData["privateMobile"] = this.getPhone(
                this.craftsmanData.phones,
                "privateMobile"
              );
              this.craftsmanData["businessMobile"] = this.getPhone(
                this.craftsmanData.phones,
                "businessMobile"
              );
            })
            .catch((err) => {
              console.log(err.response);
              this.$modal.show(
                OkModal,
                {
                  text: this.$t("message.oopsSomethingWentWrong"),
                  modalClass: this.modalClasses.okErrorClass,
                },
                {
                  width: this.modalWidth(),
                  height: "auto",
                }
              );
            });
        })
        .catch((err) => {
          console.log(err);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    selectActiveTab(tab) {
      if (tab === "Total invoiced" || tab === "Summary" || tab === "Documents")
        this.showCategoryTypeTab = false;
      else this.showCategoryTypeTab = true;

      this.activeTab = tab;
    },
    checkIfStaticBudgetZero() {
      if (
        this.$store.getters.getAuth["userType"] === "craftsmen" &&
        this.sheet.static_budget == 0
      ) {
        this.$modal.show(
          OkModal,
          {
            text: this.$t("message.plsSetYourStaticBudget"),
            modalClass: this.modalClasses.okSuccessClass,
          },
          {
            width: this.modalWidth(),
            height: "auto",
          }
        );
      }
    },
    deleteAdditionalBudget(additionalBudgetId) {
      const msg = this.$t("message.areYouSureDeleteBudget");

      this.$modal.show(
        DialogModal,
        {
          text: msg,
          param: additionalBudgetId,
          textColor: "#c44133",
          event: "confirmDeleteAdditionalBudget",
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    totalInvoiced(data) {
      this.sheet.total_invoiced = data;
    },
    confirmDeleteAdditionalBudget(additionalBudgetId) {
      let self = this;

      self
        .update(
          this.apiPrefix,
          this.sheetApiUrl + `remove-additional-budget/${additionalBudgetId}`,
          "",
          ""
        )
        .then(() => {
          // retrieve sheet data after the selected additional budget is removed
          this.getSheetData();

          let msg = self.$t("message.additionalBudgetSuccesfullyRemoved");
          self.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: self.modalClasses.okSuccessClass,
            },
            {
              width: self.modalWidth(),
              height: "auto",
            }
          );

          this.documents = [];
        })
        .catch((err) => {
          if (err.response !== undefined) {
            let msg = self.createErrorMessage(
              self.parseErrors(err.response.data)
            );

            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okErrorClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          }
        });
    },
    updateTargetCost(variable) {
      this.sheet.target_budget = variable;
    },
    updateStaticBudget(variable) {
      this.sheet.static_budget = variable;
    },
    handleImportCategories(data) {
      this.post(
        this.apiPrefix,
        this.categoriesApiUrl + "import-categories/",
        "",
        {
          sheet_id: this.sheet.id,
          categories: data,
        }
      )
        .then((resp) => {
          for (const cat of resp.data) {
            this.sortCategoriesData(cat);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    importCategories() {
      this.$modal.show(
        ImportCategoriesModal,
        {
          sheetId: this.sheet.id,
          userId: this.sheet.user.id,
        },
        {
          width: "1200px",
          height: "auto",
        }
      );
    },
    updateCategoryName(data) {
      this.update(this.apiPrefix, this.categoriesApiUrl, data.id, {
        name: data.name,
        type: data.type,
      })
        .then((resp) => {
          this.categories[resp.data.type] = this.categories[resp.data.type].map(
            (category) => {
              if (category.id === resp.data.id) {
                category.name = resp.data.name;
                return category;
              }
              return category;
            }
          );
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    updateCategoryNameDialog(category) {
      this.$modal.show(
        NameModal,
        {
          name: category.name,
          categoryId: category.id,
          type: category.type,
          heading: this.$t("message.updateCategoryName"),
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    sheetChanged(data) {
      this.sheet = data;
    },
    addAdditionalBudget() {
      let self = this;

      let textTask = this.formatTaskMessage(
        this.$store.getters.getFullName,
        this.sheet.user.company_name,
        this.selectedMonthAdditionalBudgets
      );

      this.update(
        this.apiPrefix,
        this.sheetApiUrl + "add-additional-budget/",
        this.sheet.id,
        {
          description: this.additionalBudgetDescription,
          offer_number: this.additionalBudgetOfferNumber,
          additional_budgets: this.selectedMonthAdditionalBudgets,
          task: {
            text: textTask,
            additional_data: {
              description: this.additionalBudgetDescription,
              offer_number: this.additionalBudgetOfferNumber,
              additional_budgets: this.selectedMonthAdditionalBudgets,
              sheet_id: this.sheet.id,
              project_id: this.sheet.project.id,
              //  user_requested: this.$store.getters.getAuth['userId'],
              company_name: this.sheet.user.company_name,
            },
            project_id: this.sheet.project.id,
            sheet_id: this.sheet.id,
            name: "approve_additional_budget",
          },
        }
      )
        .then(() => {
          // get overall sheet data after additional budget added
          this.getSheetData();

          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.allAdditionalBudgetsSuccessfullyAdded"),
              modalClass: this.modalClasses.okSuccessClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );

          this.clearAdditionalBudgetFields();
        })
        .catch((err) => {
          this.clearAdditionalBudgetFields();
          let msg = self.createErrorMessage(
            self.parseErrors(err.response.data.errors)
          );

          this.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    clearAdditionalBudgetFields() {
      this.additionalBudgetDescription = "";
      this.additionalBudgetOfferNumber = "";
      this.selectedMonthAdditionalBudgets = [];
      this.additionalBudgetSum = 0;
      this.componentKey++;
    },
    formatNotificationMessage(fullName, selectedMonthAdditionalBudgets) {
      let mainText =
        fullName + " " + this.$t("message.hasRequestedAdditionalBudget");
      let listOfBudgets = "";

      for (let i = 0; i < selectedMonthAdditionalBudgets.length; i++) {
        listOfBudgets +=
          "\n" +
          this.removeDayFromDate(selectedMonthAdditionalBudgets[i].value) +
          " " +
          selectedMonthAdditionalBudgets[i].amount +
          " (CHF)";
      }
      return mainText + listOfBudgets;
    },
    formatTaskMessage(fullName, companyName, selectedMonthAdditionalBudgets) {
      let mainText =
        fullName +
        " (" +
        companyName +
        ") " +
        this.$t("message.hasRequestedAdditionalBudget") +
        ":";
      let listOfBudgets = "";

      for (let i = 0; i < selectedMonthAdditionalBudgets.length; i++) {
        listOfBudgets += `\n ${this.$t(
          "message.month"
        )}: ${this.removeDayFromDate(
          selectedMonthAdditionalBudgets[i].value
        )} , ${this.$t("message.amount")}: CHF ${
          selectedMonthAdditionalBudgets[i].amount
        }`;
      }
      return mainText + listOfBudgets;
    },
    requestAdditionalBudget() {
      let self = this;

      let textNotification = this.formatNotificationMessage(
        this.$store.getters.getFullName,
        this.selectedMonthAdditionalBudgets
      );
      let textTask = this.formatTaskMessage(
        this.$store.getters.getFullName,
        this.sheet.user.company_name,
        this.selectedMonthAdditionalBudgets
      );

      if (!this.sheet.requested_additional_budget) {
        this.update(
          this.apiPrefix,
          this.sheetApiUrl + "request-additional-budget/",
          this.sheet.id,
          {
            notification: {
              sender_id: this.$store.getters.getAuth["userId"],
              recipient_id: this.sheet.project.created_by,
              text: textNotification,
            },
            task: {
              for_user_id: this.sheet.project.created_by,
              text: textTask,
              additional_data: {
                description: this.additionalBudgetDescription,
                offer_number: this.additionalBudgetOfferNumber,
                additional_budgets: this.selectedMonthAdditionalBudgets,
                sheet_id: this.sheet.id,
                project_id: this.sheet.project.id,
                user_requested: this.$store.getters.getAuth["userId"],
                company_name: this.sheet.user.company_name,
              },
              project_id: this.sheet.project.id,
              sheet_id: this.sheet.id,
              name: "approve_additional_budget",
            },
          }
        )
          .then((resp) => {
            this.sheet = resp.data;

            this.clearAdditionalBudgetFields();

            this.$modal.show(
              OkModal,
              {
                text: this.$t("message.additionalBudgetSuccessfullyRequested"),
                modalClass: this.modalClasses.okSuccessClass,
              },
              {
                width: this.modalWidth(),
                height: "auto",
              }
            );
          })
          .catch((err) => {
            this.clearAdditionalBudgetFields();
            let msg = self.createErrorMessage(
              self.parseErrors(err.response.data.errors)
            );

            this.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: this.modalClasses.okErrorClass,
              },
              {
                width: this.modalWidth(),
                height: "auto",
              }
            );
          });
      }
    },
    formatNumber(input) {
      // format is function in generalMixin.js
      return this.format(input);
    },
    getTheListOfMonths() {
      // method for returning the list of months in which documents
      // have been uploaded

      this.getList(
        this.apiPrefix,
        this.sheetApiUrl + `get-months-list/${this.$route.params.id}`
      )
        .then((resp) => {
          this.months = resp.data.document_dates;
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },

    // Adding categories
    addCategory(data) {
      data["sheet"] = this.$route.params["id"];
      data["user"] = this.sheet.user.id;
      let self = this;

      this.post(this.apiPrefix, this.categoriesApiUrl, "", data)
        .then((resp) => {
          this.lastCategoryAdded = resp.data.object.type;
          console.log(resp.data.object);
          this.sortCategoriesData(resp.data.object);
        })
        .catch((err) => {
          let msg = self.createErrorMessage(
            self.parseErrors(err.response.data.errors)
          );

          self.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: self.modalClasses.okErrorClass,
            },
            {
              width: self.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    addCategoryDialog(data) {
      this.$modal.show(
        InputModal,
        {
          heading: data.heading,
          placeholderName: data.name,
          placeholderValue: data.value,
          type: data.type,
          is_additional: false,
          event: "addCategory",
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },
    budgetDone() {
      this.getList(
        this.apiPrefix,
        this.costsBudgetApiUrl + `?is_actual=False&sheet_id=${this.sheet.id}`
      ).then((resp) => {
        if (resp.data.length) {
          this.$modal.show(
            DialogModal,
            {
              text: this.$t("message.areSureConfirmBudget"),
              event: "budgetDone",
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        } else {
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.addBudgetFirst"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        }
      });
    },
    confirmBudgetDone() {
      this.post(this.apiPrefix, this.notificationsApiUrl, "", {
        sender: this.$store.getters.getAuth["userId"],
        recipient: this.sheet.project.created_by,
        text: `${this.$store.getters.getFullName} has completed budget for project ${this.sheet.project.name}.`,
        action: "budget_completed",
        additional_data: this.sheet.id,
      })
        .then((resp) => {
          console.log(resp);
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    setActiveClass(type) {
      for (const key in this.active) {
        if (this.active.hasOwnProperty(key)) {
          if (key !== type) {
            this.active[key] = false;
          } else {
            this.active[key] = true;
          }
        }
      }
    },
    getPhone(phones, type) {
      for (const phone of phones) {
        if (phone.type === type) {
          return phone.number;
        }
      }
    },
    confirmCategory(data) {
      this.update(this.apiPrefix, this.categoriesApiUrl, data.id, {
        is_approved: !data.is_approved,
        type: data.type,
      })
        .then((resp) => {
          const category = resp.data;
          const index = this.findByProperty(
            this.categories[category.type],
            "id",
            category.id
          );
          this.categories[category.type][index].is_approved = !this.categories[
            category.type
          ][index].is_approved;
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    approveAdditionalCategory(category) {
      if (this.$store.getters.getAuth["userType"] === "superuser") {
        const msg = `${this.$t("message.approveUsingOf")} ${category.type} ${
          category.name
        }?`;
        if (category.is_additional && !category.is_approved) {
          this.$modal.show(
            DialogModal,
            {
              text: msg,
              event: "confirmCategory",
              param: category,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        } else if (category.is_additional && category.is_approved) {
          const msg = `${this.$t("message.forbidUsingOf")} ${category.type} ${
            category.name
          }?`;
          this.$modal.show(
            DialogModal,
            {
              text: msg,
              event: "confirmCategory",
              param: category,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        }
      }
    },
    updateDetails() {
      let self = this;
      const dataForUpdate = JSON.parse(JSON.stringify(this.sheet))
      // format dates for backend  before update
      dataForUpdate.start_date = this.$moment(dataForUpdate.start_date).startOf('month').format(this.formatBackendString)
      if(dataForUpdate.end_date){
          dataForUpdate.end_date = this.$moment(dataForUpdate.end_date).startOf('month').format(this.formatBackendString)
      }

      this.update(this.apiPrefix, this.sheetApiUrl, this.id, dataForUpdate)
        .then(() => {
          let msg = self.$t("message.sheetSuccesfullyUpdated");
          this.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: self.modalClasses.okSuccessClass,
            },
            {
              width: self.modalWidth(),
              height: "auto",
            }
          );
        })
        .catch((err) => {
          let msg = self.createErrorMessage(
            self.parseErrors(err.response.data.errors)
          );
          self.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: self.modalClasses.okErrorClass,
            },
            {
              width: self.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    setLastRouteProjectId() {
      if (this.lastRoute && this.projectId) {
        this.$store.commit("setLastRoute", this.lastRoute);
        this.$store.commit("setProjectId", this.projectId);
      } else if (this.lastRoute) {
        this.$store.commit("setLastRoute", this.lastRoute);
        this.$store.commit("setProjectId", null);
      }
    },
    goBack() {
      this.$router.push({
        name: this.$store.getters.getLastRoute,
        params: { id: this.$store.getters.getProjectId },
      });
    },
    downloadToCsv() {
      this.getList(
        this.apiPrefix,
        this.costsBudgetApiUrl + "costs-budget-per-sheet/",
        `${this.$route.params["id"]}`
      )
        .then((resp) => {
          let data = resp.data.data;

          if (data.length > 0) {
            this.job = data[0].sheet.job.name;
            const mappedData = data.map((row) => ({
              date: row.date,
              categoryType: row.category.type,
              categoryName: row.category.name,
              price: row.category.value,
              amount: row.amount,
              total: row.total,
              actualOrBudget: row.is_actual ? "actual" : "budget",
            }));

            let csvData = this.objectToCsv(mappedData);
            this.download(csvData);
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    objectToCsv(data) {
      let csvRows = [];

      //get the headers
      let headers = Object.keys(data[0]);
      csvRows.push(headers.join(","));

      // loop over the rows
      for (const row of data) {
        let values = headers.map((header) => {
          // form escaped comma separated values
          ("" + row[header.replace]).replace(/"/g, '\\"');
          return `${row[header]}`;
        });
        csvRows.push(values.join(","));
      }

      return csvRows.join("\n");
    },
    download(data) {
      let blob = new Blob([data], { type: "text/csv" });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);

      let documentName =
        this.craftsmanData.company_name +
        "-" +
        this.job +
        "-" +
        new Date().toJSON().slice(0, 10).replace(/-/g, "/") +
        ".csv";
      a.setAttribute("download", documentName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },

  computed: {
    // staticPlusAdditional: function (){
    //    return parseFloat(this.sheet.static_budget)
    // },
    budgetActualComputed() {
      return this.budgetOrActual;
    },
    computedCategories() {
      return this.categories;
    },
    computedLastCategory() {
      return this.lastCategoryAdded;
    },
    computedSheetClosedStyles() {
      if (
        this.sheet.is_closed &&
        this.$store.getters.getAuth["userType"] !== "superuser"
      ) {
        return {
          pointerEvents: "none",
          opacity: 0.2,
        };
      }

      return {
        pointerEvents: "auto",
        opacity: 1,
      };
    },
  },
  mounted() {
    // EventBus.$on('REMOVE_DOCUMENT', (params) => {
    //  // console.log('ASDASDASDASD')
    //   console.log(params)
    //    const msg = this.$t("message.areYouSureRemove");
    //       this.$modal.show(
    //         DialogModal,
    //         {
    //           text: msg,
    //           param: params,
    //           textColor: "#c44133",
    //           event: "confirmRemoveDocument",
    //         },
    //         {
    //           width: this.modalWidth(),
    //           height: "auto",
    //         }
    //       );
    // })
  },
};
</script>

<style>
label {
  font-weight: bold;
}

input {
  height: 30px;
}

.addRemoveAddBudgetButton {
  width: 49%;
  height: 50px;
  padding: 5px;
  white-space: normal;
  font-size: 0.8em;
  margin: 0 1% 1% 0;
}

.add-category-button {
  cursor: pointer;
  height: 25px;
  width: 25px;
}

.add-category-button-plus {
  font-size: 0.9em;
  position: absolute;
  top: 6px;
  left: 6.5px;
}

.craftsman-table {
  width: 80%;
}

.craftsman-table td {
  padding: 3px 9px;
}

/* .craftsman-table td:nth-child(odd) {
        font-weight: bold;
    } */

.loaded-categories-table td {
  padding: 1px;
}

.flex-container {
  display: flex;
  flex-grow: 1;
}

.flex-container div {
  background-color: #0b93d5;
  border: 1px solid white;
  color: white;
  flex-basis: 20%;
  margin-bottom: 2%;
  padding: 5px;
}

.flex-container div:hover {
  background-color: rgba(11, 147, 213, 0.8);
}

.activeType {
  background-color: white !important;
  border: 1px solid #0b93d5 !important;
  color: #0b93d5 !important;
  font-weight: bold !important;
}

.notActiveType a {
  color: white !important;
}

.navLinkActive {
  color: #0b93d5;
}

.tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #000;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  right: -35px;
  top: -65px;
  z-index: 1;
}

.tooltip-wrapper {
  position: relative;
}

.visible {
  visibility: visible;
}

/* .tooltiptextvisible_personnel {
        visibility: visible;
    }

    .tooltiptextvisible_material {
        visibility: visible;
    }

    .tooltiptextvisible_foreignService {
        visibility: visible;
    }

    .tooltiptextvisible_inventory {
        visibility: visible;
    }

    .tooltiptextvisible_additionalCosts {
        visibility: visible;
    } */

input {
  font-size: 12px;
}

.go-back {
  color: grey;
  cursor: pointer;
  margin: 0 0 0 10px;
  padding: 15px 5px 5px 5px;
}

.projectNotActive {
  pointer-events: none;
}

td {
  text-align: left;
}

.month-picker__container {
  position: absolute;
  z-index: 100000;
  font-size: 0.9em;
  background: white;
}

.month-picker__year {
  margin-top: 10px;
  margin-bottom: 25px;
}

.additionalCategory {
  background: rgba(255, 0, 0, 0.2);
}

.additionalCategoriesApproved {
  background: rgba(0, 255, 0, 0.2);
}

.requireAdditionalBudgetDisabled {
  background-color: rgba(52, 152, 219, 0.7);
  pointer-events: none;
}

.loaded-categories-table tbody tr td:first-child {
  cursor: pointer;
}

.toolTipTextDocument {
  visibility: hidden;
  width: 200px;
  background-color: #000;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  margin-left: 20px;
  margin-top: -30px;
  z-index: 1;
}

.budget {
  background-color: #ff9cbb;
}

.actual {
  background-color: #cfcacb;
}

.summary {
  background-color: #f5c476;
}

.totalInvoiced {
  background-color: #c1fca9;
}

.documents {
  background-color: #ffbeb8;
}

@media screen and (min-width: 1366px) {
  .btnWidth {
    width: 400px;
  }
}

@media screen and (max-width: 1366px) {
  .btnWidth {
    width: 250px;
  }
}

.switch {
  margin-top: 7px;
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.delete-btn {
  background: #c1fca9;
}

.change-color:hover {
  background-color: turquoise !important;
}

.sheetClosed {
  pointer-events: none !important;
  opacity: 0.1 !important;
}
</style>